export default __webpack_public_path__ + "static/media/group.7cafeaf1.svg";